import { CurvedHouseBox } from '@icons/Boxes';
import { ChatIcon } from '@icons/ChatIcon';
import { EmailIcon } from '@icons/EmailIcon';
import { RightArrow } from '@icons/RightArrow';
import { TelephoneIcon } from '@icons/TelephoneIcon';
import { Link } from 'components/Link';
import type { ContactCard as TContactCard } from 'server/repository/hygraph/generated/graphqlTypes';
import {
  BoxContainer,
  BoxWrapper,
  CallToAction,
  ContactInfo,
  Container,
  Field,
  FieldWrapper,
  HiddenUntilHoverOrFocus,
  Icon,
  Label,
  LinkContents,
  LinkLabel,
  Text,
  TextContainer,
  Title,
} from './styles';

export const ContactCard = ({
  id = 'contact-card',
  title,
  field1Label,
  field1Text,
  field2Label,
  field2Text,
  link,
  contactTypeIcon,
}: TContactCard) => (
  <Container>
    <BoxWrapper>
      <BoxContainer>
        <CurvedHouseBox width="0" />
      </BoxContainer>
    </BoxWrapper>
    <ContactInfo data-test={[`${id}-contact-info`]} className="trigger-action" tabIndex={0}>
      {contactTypeIcon && (
        <Icon data-test={[`${id}-icon`]}>
          {contactTypeIcon === 'Telephone' && <EmailIcon />}
          {contactTypeIcon === 'Email' && <TelephoneIcon />}
          {contactTypeIcon === 'Chat' && <ChatIcon />}
        </Icon>
      )}
      <TextContainer className="shift">
        <Title data-test={[`${id}-title`]}>{title}</Title>
        <FieldWrapper data-test={[`${id}-field-wrapper`]}>
          <Field data-test={[`${id}-field1`]}>
            {field1Label && <Label data-test={[`${id}-label1`]}>{field1Label}</Label>}
            <Text data-test={[`${id}-text1`]}>{field1Text}</Text>
          </Field>
          <Field data-test={[`${id}-field2`]}>
            {field2Label && <Label data-test={[`${id}-label2`]}>{field2Label}</Label>}
            <Text data-test={[`${id}-text2`]}>{field2Text}</Text>
          </Field>
        </FieldWrapper>
        {link && (
          <CallToAction data-test={[`${id}-cta`]}>
            <Link href={link.url || ''} target="_blank">
              <HiddenUntilHoverOrFocus className="hidden-until-hover-or-focus-on-desktop">
                <LinkContents data-test={[`${id}-link-contents`]}>
                  <LinkLabel data-test={[`${id}-link-label`]}>{link.displayName}</LinkLabel>
                  <RightArrow data-test={[`${id}-right-arrow`]} />
                </LinkContents>
              </HiddenUntilHoverOrFocus>
            </Link>
          </CallToAction>
        )}
      </TextContainer>
    </ContactInfo>
  </Container>
);
